module.exports = __webpack_public_path__ + "img/mv--avatar1--sp.c1e9b8bf.png";